exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.price[data-v-303e0309] {\n  font-size: 3.5em;\n}\n.button-custom[data-v-303e0309] {\n  font-size: 16px;\n  padding: 15px 0;\n  height: 3em;\n}\n.main-container[data-v-303e0309] {\n  padding: 2.5em 2.5em;\n}\n@media (max-width: 1280px) {\n.button-custom[data-v-303e0309] {\n    font-size: 16px;\n    padding: 10px 0;\n}\n}\n@media (max-width: 650px) {\n.main-container[data-v-303e0309] {\n    padding: 1.5em 2.2em;\n}\n.button-custom[data-v-303e0309] {\n    font-size: 14px;\n    padding: 15px 0;\n}\n}\n@media (max-width: 400px) {\n.main-container[data-v-303e0309] {\n    padding: 20px 15px;\n}\n.responsive-title[data-v-303e0309] {\n    font-size: 1em;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-303e0309","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/multiplePhonePlan/summaryBox/NewSummaryCard.vue
// module id = 718
// module chunks = 0